import { render, staticRenderFns } from "./change-cus-record.vue?vue&type=template&id=2b413b32&scoped=true"
import script from "./change-cus-record.vue?vue&type=script&lang=js"
export * from "./change-cus-record.vue?vue&type=script&lang=js"
import style0 from "./change-cus-record.vue?vue&type=style&index=0&id=2b413b32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b413b32",
  null
  
)

export default component.exports